// @flow
import React from "react";

const CalendarIcon = () => {
    return (<i className="far fa-lg fa-calendar-alt p-0 m-0"/>);
}

export default CalendarIcon;